import { createQueryKeyStore } from "@lukemorales/query-key-factory";
import { skipToken } from "@tanstack/react-query";

import { getOnboardingUser } from "@/features/onboarding/api/account";
import type { OnboardingUser } from "@/features/onboarding/models";
import type { Question } from "@/shared/models";
import { getInitialQuestion, getQuestion } from "./questions";

export const onboardingQueriesStore = createQueryKeyStore({
  onboarding: {
    user: (code?: OnboardingUser["code"]) => ({
      queryKey: [code],
      queryFn: code ? () => getOnboardingUser(code) : (skipToken as never),
    }),

    filteringQuestions: {
      queryKey: null,
      contextQueries: {
        initial: (bmi?: number) => ({
          queryKey: [bmi],
          queryFn: bmi ? () => getInitialQuestion(bmi) : (skipToken as never),
        }),
        next: (questionId?: Question["id"]) => ({
          queryKey: [questionId],
          queryFn: questionId
            ? () => getQuestion(questionId)
            : (skipToken as never),
        }),
      },
    },
  },
});
